export const COMPONENT_STATE_STATIC = 'static';
export const COMPONENT_STATE_FADEOUT = 'fadeOut';
export const COMPONENT_STATE_LOADING = 'loading';
export const COMPONENT_STATE_FADEIN = 'fadeIn';

export const ComponentStates = [
  COMPONENT_STATE_STATIC,
  COMPONENT_STATE_FADEOUT,
  COMPONENT_STATE_LOADING,
  COMPONENT_STATE_FADEIN,
];
